import axios, { AxiosPromise } from "axios";

export const FETCH_CUSTOM_FOOTER = "AKASHA_FETCH_CUSTOM_FOOTER";
export const FETCH_CUSTOM_FOOTER_FULFILLED = `${FETCH_CUSTOM_FOOTER}_FULFILLED`;
export const FETCH_CUSTOM_FOOTER_REJECTED = `${FETCH_CUSTOM_FOOTER}_REJECTED`;

interface AxiosPromiseResponse {
  data: any;
}

interface GetCustomFooterAction {
  type: typeof FETCH_CUSTOM_FOOTER;
  payload: AxiosPromise<AxiosPromiseResponse>;
}

export interface GetCustomFooterActionResponse {
  type:
    | typeof FETCH_CUSTOM_FOOTER_FULFILLED
    | typeof FETCH_CUSTOM_FOOTER_REJECTED;
  payload: AxiosPromiseResponse;
}

export function getCustomFooter(
  templateName: string,
  additionalHeaders?: any
): GetCustomFooterAction {
  let templateContentUrl = `${process.env.REACT_APP_CMS_TEMPLATE_CONTENT_SERVICE_ENDPOINT}/${templateName}`;

  return {
    type: FETCH_CUSTOM_FOOTER,
    payload: axios.get(templateContentUrl, {
      headers: {
        ...additionalHeaders,
        "Customer-Facing-Tool": process.env.REACT_APP_CFT,
        CFT: process.env.REACT_APP_CFT,
        MSessionId: sessionStorage.getItem("sessionId"),
      },
    })
  };
}
